/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  Sidebar,
  Menu,
  MenuItem as ProMenuItem,
  SubMenu as ProSubMenu,
} from "react-pro-sidebar";
import { useNavigate, useLocation } from "react-router-dom";
// import { useDispatch } from "react-redux";
import { useDispatch, useSelector } from "react-redux";
import * as Sentry from "@sentry/react";
import DashboardVector from "../../../assets/Vector/DashboardVector.svg";
import MastersetupVector from "../../../assets/Vector/MastersetupVector.svg";
import MemberVector from "../../../assets/Vector/MemberVector.svg";
import RegularcontributionVector from "../../../assets/Vector/RegularcontributionVector.svg";
import ReportsVector from "../../../assets/Vector/ReportsVector.svg";
import OnlineContributionVector from "../../../assets/Vector/OnlineContribution.svg";
import LogoutVector from "../../../assets/Vector/LogoutVector.svg";
import DemoImage from "../../../assets/images/DemoImage.png";
import { ROUTES } from "../../Routes";
// import { ROUTES } from "../../Routes";
import { logoutAction } from "../../../Config/Redux/actions/authActions";
import { SERVICES } from "../Services";
import { get } from "../ApiHandler/apihandler";
import {
  setAdminData,
  setUserData,
} from "../../../Config/Redux/actions/userActions";

const MainContainer = styled.div`
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25);
  width: 260px;
  // height: 100vh;
  // min-height: 200vh;
  display: flex;
  flex-direction: column;
  // height: ${({ overflowY }) => (overflowY ? "100vh" : "auto")};
  overflow-y: ${({ overflowY }) => (overflowY ? "scroll" : "visible")};
`;
const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
const Ellipse = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 100px;
  background: rgba(4, 61, 144, 0.18);
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const NameHeading = styled.p`
  color: #000;
  // font-family: Noto Sans;
  font-size: 18px;
  margin: 0 0;
  // font-style: normal;
  font-weight: 700;
`;
const DesignationHeading = styled.p`
  color: #484848;
  // font-family: Noto Sans;
  font-size: 14px;
  margin: 0 0;
  // font-style: normal;
  font-weight: 400;
  // line-height: normal;
`;
const Divider = styled.div`
  width: 80%;
  margin: 20px auto;
  height: 1px;
  background: rgba(76, 78, 141, 0.35);
`;
const LogoutContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  // align-items: center;
  // justify-content: center;
  padding-left: 24px;
  gap: 20px;
  cursor: pointer;
`;

const LogOutItems = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  // padding-left: 30px;
`;
const CustomMenuItem = styled(ProMenuItem)`
  color: rgba(72, 72, 72, 0.75);
  font-size: 14px;
  font-weight: 400;

  // Active state styling
  ${({ $isActive }) =>
    $isActive &&
    `
    background-color: #4c4e8d !important;
    color: #f8f1f1ff !important;
    border-radius: 8px;
    font-weight: 600;
    
    &:hover {
      background-color: #18181cff !important;
      color: rgba(15, 0, 0, 1) !important; 
    }
  `}

  &:hover {
    background-color: ${({ $isActive }) =>
      $isActive ? "#4c4e8d" : "rgba(1, 12, 17, 0.3)"};
    border-radius: 8px;
  }
`;
const CustomSubMenu = styled(ProSubMenu)`
  color: rgba(72, 72, 72, 0.75);
  font-size: 14px;
  font-weight: 400;
`;
const LogoutText = styled.p`
  color: #444;
  font-size: 16px;
  font-weight: 400;
`;
const Icon = styled.img`
  width: 16px;
  height: 16px;
`;

const Footer = styled.footer`
  color: #8b8b8b;
  font-size: 12px;
  font-weight: 400;
  left: 0px;
  bottom: 0px;
  text-align: center;
  padding: 10px 25px;
`;

function SideBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [memberData, setMemberData] = useState({});
  const [profileData, setProfileData] = useState({});
  const SelectedUser = useSelector((state) => state.user);
  const memberId = localStorage.getItem("memberId");
  const currentYear = new Date().getFullYear();
  const getInitials = (name) => {
    if (typeof name !== "string") {
      return "";
    }

    const initials = name
      .split(" ")
      .map((word) => word.charAt(0))
      .join("")
      .toUpperCase();

    return initials;
  };

  const getUserProfile = async () => {
    try {
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        // setMemberData(data.data)
        dispatch(setAdminData(data.data));
      }
      if (response.status === 403) {
        dispatch(logoutAction());
      } else {
        // eslint-disable-next-line no-console
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const getUserProfileImage = async () => {
    try {
      const url = `${SERVICES.GET_MEMBER}/${memberId}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setMemberData(data.data);
      }
      if (response.status === 403) {
        dispatch(logoutAction());
      } else {
        // eslint-disable-next-line no-console
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const getUserRole = async () => {
    try {
      const url = `${SERVICES.GET_PROFILE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setProfileData(data.data);
      }
      if (response.status === 403) {
        dispatch(logoutAction());
      } else {
        // eslint-disable-next-line no-console
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  useEffect(() => {
    getUserProfile();
    getUserProfileImage();
    getUserRole();
  }, []);
  const handleBranch = () => {
    navigate(ROUTES.BRANCH_DETAILS);
  };
  const handleDashboard = () => {
    navigate(ROUTES.DASHBOARD);
  };
  const handleMessageTicker = () => {
    navigate(ROUTES.MESSAGE_TICKER);
  };
  const handlePayableCity = () => {
    navigate(ROUTES.PAYABLE_CITY);
  };
  const handleContributionCycleDetails = () => {
    navigate(ROUTES.CONTRIBUTION_CYCLE);
  };
  const handleChapterLevelContributionCycleDetails = () => {
    navigate(ROUTES.CHAPTER_LEVEL_CONTRIBUTION_CYCLE);
  };
  const handleBankDetails = () => {
    navigate(ROUTES.BANK_DETAILS);
  };
  const handleDrawnBankDetails = () => {
    navigate(ROUTES.DRAWN_BANK_DETAILS);
  };
  const handleReceiptTypes = () => {
    navigate(ROUTES.RECEIPT_TYPES);
  };
  const handleCancelledReceiptReport = () => {
    navigate(ROUTES.CANCELLED_RECEIPT_REPORT);
  };
  const handletotalReceiptReport = () => {
    navigate(ROUTES.TOTAL_RECEIPT_REPORT);
  };
  const handletotalCancelledReceiptReport = () => {
    navigate(ROUTES.TOTAL_CANCELLED_RECEIPT_REPORT);
  };
  const handletotalCollectionReport = () => {
    navigate(ROUTES.TOTAL_COLLECTION_REPORT);
  };
  const handletotalCollectionChapterReport = () => {
    navigate(ROUTES.TOTAL_COLLECTION_CHAPTER_REPORT);
  };
  const handleContributionCollectionReport = () => {
    navigate(ROUTES.CONTRIBUTION_COMPARISON_REPORT);
  };
  const handlechequesDetailsReport = () => {
    navigate(ROUTES.CHEQUES_DETAILS_REPORT);
  };
  const handlecashReport = () => {
    navigate(ROUTES.CASH_REPORT);
  };
  const handleDownloadReports = () => {
    navigate(ROUTES.DOWNLOAD_REPORTS);
  };
  const handleMemberSearch = () => {
    navigate(ROUTES.MEMBER_SEARCH);
  };
  const handlePendingOnlineContribution = () => {
    navigate(ROUTES.PENDING_ONLINE_CONTRIBUTION);
  };
  const handleCaptureOnlineContribution = () => {
    navigate(ROUTES.CAPTURE_ONLINE_CONTRIBUTION);
  };
  const handleReportCaptureOnlineContribution = () => {
    navigate(ROUTES.REPORT_CAPTURE_ONLINE_CONTRIBUTION);
  };
  const handleSearchOnlineContributionPrintForm = () => {
    navigate(ROUTES.SEARCH_ONLINE_CONTRIBUTION_PRINT_FORM);
  };
  const handleTaxUtilityReport = () => {
    navigate(ROUTES.TAX_UTILITY_REPORT);
  };
  const handleBankDepositDetails = () => {
    navigate(ROUTES.BANK_DEPOSIT_DETAILS);
  };
  const handleForm10BESearch = () => {
    navigate(ROUTES.FORM_10_BE_SEARCH);
  };
  const Logout = () => {
    dispatch(logoutAction());
  };
  return (
    <MainContainer>
      <ImageContainer>
        <Ellipse>
          {memberData.profilePhotoUrl !== null ? (
            <img
              src={memberData?.profilePhotoUrl}
              // alt="demoimage"
                 style={{
      width: "100px",        // ← Ellipse ki width ke barabar
      height: "100px",       // ← Ellipse ki height ke barabar
      borderRadius: "50%",   // ← Circular clip
      objectFit: "cover",    // ← Image aspect ratio maintain karte hue fill karega
      display: "block",
    }}
            />
          ) : (
            <div
              style={{
                fontSize: "24px",
              }}
            >
              {getInitials(SelectedUser.adminData?.fullName)}
            </div>
          )}
        </Ellipse>
        <NameHeading>{SelectedUser.adminData?.fullName}</NameHeading>
      </ImageContainer>
      <Divider />
      <Sidebar>
        <Menu>
          {profileData?.assignedRoles?.includes("contributionAdmin") && (
            <CustomMenuItem
              icon={<Icon src={DashboardVector} />}
              onClick={handleDashboard}
              $isActive={location.pathname === ROUTES.DASHBOARD}
            >
              Dashboard
            </CustomMenuItem>
          )}
          {profileData?.assignedRoles?.includes("contributionAdmin") && (
            <CustomSubMenu
              label="Master Setup"
              icon={<Icon src={MastersetupVector} />}
            >
              {profileData?.assignedRoles?.includes("contributionAdmin") && (
                <CustomMenuItem
                  onClick={handleMessageTicker}
                  $isActive={location.pathname === ROUTES.MESSAGE_TICKER}
                >
                  Message Ticker
                </CustomMenuItem>
              )}
              <CustomSubMenu label="Setup Details">
                {profileData?.assignedRoles?.includes("contributionAdmin") && (
                  <CustomMenuItem
                    onClick={handleReceiptTypes}
                    $isActive={location.pathname === ROUTES.RECEIPT_TYPES}
                  >
                    Receipt Types
                  </CustomMenuItem>
                )}
                {profileData?.assignedRoles?.includes("contributionAdmin") && (
                  <CustomMenuItem
                    onClick={handlePayableCity}
                    $isActive={location.pathname === ROUTES.PAYABLE_CITY}
                  >
                    Payable City
                  </CustomMenuItem>
                )}
                {profileData?.assignedRoles?.includes("contributionAdmin") && (
                  <CustomMenuItem
                    onClick={handleContributionCycleDetails}
                    $isActive={location.pathname === ROUTES.CONTRIBUTION_CYCLE}
                  >
                    Contribution Cycle
                  </CustomMenuItem>
                )}
                {profileData?.assignedRoles?.includes("contributionAdmin") && (
                  <CustomMenuItem
                    onClick={handleChapterLevelContributionCycleDetails}
                    $isActive={
                      location.pathname ===
                      ROUTES.CHAPTER_LEVEL_CONTRIBUTION_CYCLE
                    }
                  >
                    Chapter Contribution Cycle
                  </CustomMenuItem>
                )}
                {profileData?.assignedRoles?.includes("contributionAdmin") && (
                  <CustomMenuItem
                    onClick={handleBankDetails}
                    $isActive={location.pathname === ROUTES.BANK_DETAILS}
                  >
                    Bank Details
                  </CustomMenuItem>
                )}
              </CustomSubMenu>
              {profileData?.assignedRoles?.includes("contributionAdmin") && (
                <CustomMenuItem
                  onClick={handleBranch}
                  $isActive={location.pathname === ROUTES.BRANCH_DETAILS}
                >
                  Collection Deposit Bank
                </CustomMenuItem>
              )}
              {profileData?.assignedRoles?.includes("contributionAdmin") && (
                <CustomMenuItem
                  onClick={handleDrawnBankDetails}
                  $isActive={location.pathname === ROUTES.DRAWN_BANK_DETAILS}
                >
                  Drawn Bank Details
                </CustomMenuItem>
              )}
            </CustomSubMenu>
          )}
          {(profileData?.assignedRoles?.includes("contributionAdmin") ||
            profileData?.assignedRoles?.includes("contributionDataEntry") ||
            profileData?.assignedRoles?.includes(
              "contributionOfflineDataEntry"
            )) && (
            <CustomSubMenu
              label="Regular Contribution"
              icon={<Icon src={RegularcontributionVector} />}
            >
              <CustomMenuItem
                onClick={handleMemberSearch}
                $isActive={location.pathname === ROUTES.MEMBER_SEARCH}
              >
                New Contribution
              </CustomMenuItem>
            </CustomSubMenu>
          )}
          {(profileData?.assignedRoles?.includes("contributionAdmin") ||
            profileData?.assignedRoles?.includes(
              "contributionOfflineDataEntry"
            )) && (
            <CustomSubMenu
              label="Contribution Deposit"
              icon={<Icon src={MemberVector} />}
            >
              <CustomMenuItem
                onClick={handleBankDepositDetails}
                $isActive={location.pathname === ROUTES.BANK_DEPOSIT_DETAILS}
              >
                Bank Deposit Details
              </CustomMenuItem>
            </CustomSubMenu>
          )}
          {profileData?.assignedRoles?.includes("contributionAdmin") && (
            <CustomSubMenu
              label="Online Contribution"
              icon={<Icon src={OnlineContributionVector} />}
            >
              <CustomMenuItem
                onClick={handleCaptureOnlineContribution}
                $isActive={
                  location.pathname === ROUTES.CAPTURE_ONLINE_CONTRIBUTION
                }
              >
                Capture Online Contribution
              </CustomMenuItem>
              <CustomMenuItem
                onClick={handlePendingOnlineContribution}
                $isActive={
                  location.pathname === ROUTES.PENDING_ONLINE_CONTRIBUTION
                }
              >
                Pending Online Contribution
              </CustomMenuItem>
            </CustomSubMenu>
          )}
          {(profileData?.assignedRoles?.includes("contributionAdmin") ||
            profileData?.assignedRoles?.includes("contributionDataEntry") ||
            profileData?.assignedRoles?.includes(
              "contributionOfflineDataEntry"
            )) && (
            <CustomSubMenu label="Reports" icon={<Icon src={ReportsVector} />}>
              {/* {profileData?.assignedRoles?.includes("contributionAdmin") && (
                <CustomMenuItem
                  onClick={handleCancelledReceiptReport}
                  $isActive={
                    location.pathname === ROUTES.CANCELLED_RECEIPT_REPORT
                  }
                >
                  Cancelled Receipt Report
                </CustomMenuItem>
              )} */}
              {(profileData?.assignedRoles?.includes("contributionAdmin") ||
                profileData?.assignedRoles?.includes("contributionDataEntry") ||
                profileData?.assignedRoles?.includes(
                  "contributionOfflineDataEntry"
                )) && (
                <CustomMenuItem
                  onClick={handletotalReceiptReport}
                  $isActive={location.pathname === ROUTES.TOTAL_RECEIPT_REPORT}
                >
                  Total Receipt Report
                </CustomMenuItem>
              )}
              {(profileData?.assignedRoles?.includes("contributionAdmin") ||
                profileData?.assignedRoles?.includes("contributionDataEntry") ||
                profileData?.assignedRoles?.includes(
                  "contributionOfflineDataEntry"
                )) && (
                <CustomMenuItem
                  onClick={handlechequesDetailsReport}
                  $isActive={
                    location.pathname === ROUTES.CHEQUES_DETAILS_REPORT
                  }
                >
                  Cheques/DD Reports
                </CustomMenuItem>
              )}
              {(profileData?.assignedRoles?.includes(
                "contributionOfflineDataEntry"
              ) ||
                profileData?.assignedRoles?.includes("contributionAdmin")) && (
                <CustomMenuItem
                  onClick={handlecashReport}
                  $isActive={location.pathname === ROUTES.CASH_REPORT}
                >
                  Cash Reports
                </CustomMenuItem>
              )}
              {(profileData?.assignedRoles?.includes("contributionAdmin") ||
                profileData?.assignedRoles?.includes("contributionDataEntry") ||
                profileData?.assignedRoles?.includes(
                  "contributionOfflineDataEntry"
                )) && (
                <CustomMenuItem
                  onClick={handletotalCollectionReport}
                  $isActive={
                    location.pathname === ROUTES.TOTAL_COLLECTION_REPORT
                  }
                >
                  Total Collection Report
                </CustomMenuItem>
              )}
              {profileData?.assignedRoles?.includes("contributionAdmin") && (
                <CustomMenuItem
                  onClick={handletotalCollectionChapterReport}
                  $isActive={
                    location.pathname === ROUTES.TOTAL_COLLECTION_CHAPTER_REPORT
                  }
                >
                  Total Collection Chapter Report
                </CustomMenuItem>
              )}
              {profileData?.assignedRoles?.includes("contributionAdmin") && (
                <CustomMenuItem
                  onClick={handleReportCaptureOnlineContribution}
                  $isActive={
                    location.pathname ===
                    ROUTES.REPORT_CAPTURE_ONLINE_CONTRIBUTION
                  }
                >
                  Report Capture Online Contribution
                </CustomMenuItem>
              )}
              {(profileData?.assignedRoles?.includes("contributionAdmin") ||
                profileData?.assignedRoles?.includes("contributionDataEntry") ||
                profileData?.assignedRoles?.includes(
                  "contributionOfflineDataEntry"
                )) && (
                <CustomMenuItem
                  onClick={handletotalCancelledReceiptReport}
                  $isActive={location.pathname === ROUTES.TOTAL_CANCELLED_RECEIPT_REPORT}
                >
                  Total Cancelled Receipt Report
                </CustomMenuItem>
              )}
              {profileData?.assignedRoles?.includes("contributionAdmin") && (
                <CustomMenuItem
                  onClick={handleSearchOnlineContributionPrintForm}
                  $isActive={
                    location.pathname ===
                    ROUTES.SEARCH_ONLINE_CONTRIBUTION_PRINT_FORM
                  }
                >
                  Search Online Contribution Print Form
                </CustomMenuItem>
              )}
              {profileData?.assignedRoles?.includes("contributionAdmin") && (
                <CustomMenuItem
                  onClick={handleForm10BESearch}
                  $isActive={location.pathname === ROUTES.FORM_10_BE_SEARCH}
                >
                  Form 10BE Search
                </CustomMenuItem>
              )}
              {profileData?.assignedRoles?.includes("contributionAdmin") && (
                <CustomMenuItem
                  onClick={handleTaxUtilityReport}
                  $isActive={location.pathname === ROUTES.TAX_UTILITY_REPORT}
                >
                  Tax Utility Report
                </CustomMenuItem>
              )}
              <CustomMenuItem
                onClick={handleDownloadReports}
                $isActive={location.pathname === ROUTES.DOWNLOAD_REPORTS}
              >
                Download Reports
              </CustomMenuItem>
            </CustomSubMenu>
          )}
        </Menu>
      </Sidebar>
      <Divider />
      <LogoutContainer>
        <LogOutItems onClick={Logout}>
          <Icon src={LogoutVector} />
          <LogoutText>Logout</LogoutText>
        </LogOutItems>
      </LogoutContainer>
      <Footer>
        Copyright Bharat Soka Gakkai © {currentYear}. All rights reserved.
      </Footer>
    </MainContainer>
  );
}

export default SideBar;
